import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  BookOpen,
  CircleHelp,
  LifeBuoy,
  Megaphone,
  Rocket,
  Search,
  Video,
  Wrench,
} from "lucide-react";
import { filterHelpContent } from "./helpCenterContent";

const SECTION_ICONS = {
  helpCircle: CircleHelp,
  rocket: Rocket,
  bookOpen: BookOpen,
  video: Video,
  wrench: Wrench,
  megaphone: Megaphone,
  lifeBuoy: LifeBuoy,
};

export default function HelpCenterHome() {
  const [query, setQuery] = useState("");
  const sections = filterHelpContent(query);

  return (
    <>
      <section className="help-center-hero">
        <h1>Hi, how can we help you?</h1>
        <p>
          Explore documentation to learn, understand, and master InsSure — from
          first setup through daily operations and support.
        </p>
        <div className="help-center-search">
          <Search className="help-center-search-icon" size={18} aria-hidden="true" />
          <input
            type="search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search topics and articles…"
            aria-label="Search help topics"
          />
        </div>
      </section>

      <section className="help-center-grid" aria-label="Help topics">
        {sections.length === 0 ? (
          <div className="help-center-empty">
            No topics match “{query}”. Try a different keyword.
          </div>
        ) : (
          sections.map((section) => {
            const Icon = SECTION_ICONS[section.icon] || CircleHelp;
            return (
              <Link
                key={section.slug}
                to={`/help/${section.slug}`}
                className="help-center-card"
              >
                <span className="help-center-card-icon" aria-hidden="true">
                  <Icon size={20} strokeWidth={2} />
                </span>
                <h2>{section.title}</h2>
                <p>{section.summary}</p>
                <span className="help-center-card-cta">Browse →</span>
              </Link>
            );
          })
        )}
      </section>

      <aside className="help-center-footer-strip">
        <p>
          <strong>Need more help?</strong> Support is available on business days.
          Raise a ticket or find contact details in Contact Support.
        </p>
        <Link to="/help/contact-support">Contact Support</Link>
      </aside>
    </>
  );
}
